<template>
  <div class="integrated-right">
    <div class="filter-form">
      <el-form :inline="true">
        <el-form-item label="姓名">
          <el-input placeholder="请输入" v-model="filterForm.name"></el-input>
        </el-form-item>
        <el-form-item label="人员类型">
          <el-select v-model="filterForm.personOrAccountType">
            <el-option
              v-for="item in personType"
              :key="item.id"
              :value="item.id"
              :label="item.label"
            ></el-option>
          </el-select>
          <!-- <el-input placeholder="请输入"></el-input> -->
        </el-form-item>
        <!-- <el-form-item label="职位">
          <el-input
            placeholder="请输入"
            v-model="filterForm.position"
          ></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" class="query-btn" @click="handleQuery">
            查询
          </el-button>
          <el-button type="info" @click="handleReset"> 重置 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <el-scrollbar style="flex:1;"> -->
    <div class="table-wrapper">
      <div class="operate-btns">
        <el-button
          type="primary"
          @click="handleAdd"
          class="iss-operation-button"
          icon="el-icon-plus"
          >新增</el-button
        >
        <el-button
          type="info"
          icon="el-icon-delete"
          @click="delTableData"
          :disabled="!selectedPeople.length ? true : false"
          >删除</el-button
        >
      </div>
      <el-table
        max-height="100%;"
        :data="tableData"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="姓名" prop="name"></el-table-column>
        <el-table-column label="电话" prop="phone"></el-table-column>
        <el-table-column label="人员类型" prop="position">
          <template slot-scope="{ row }">
            <span>{{ accountTypeRender(row.personOrAccountType) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="照片">
          <template slot-scope="{ row }">
            <img
              :src="getImgPath(row.fileCode)"
              style="height: 25px; width: 50px"
              @click="showViewer(getImgPath(row.fileCode), $event)"
              onerror="this.src='/images/theme/newDark/default.png'"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="page.total" class="footer">
      <el-pagination
        class="page-comp"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-size="page.pageSize"
        :total="page.total"
        :current-page="page.currentPage"
        @size-change="sizeChange"
        @current-change="pageChange"
        @prev-click="pageChange"
        @next-click="pageChange"
      />
    </div>
    <!-- </el-scrollbar> -->
    <add-integrated-person
      ref="modal"
      @refreshData="getTableData"
      :person-type="personType"
    ></add-integrated-person>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
  </div>
</template>

<script>
import AddIntegratedPerson from "./addIntegratedPerson";
import api from "../../api";
import { Bus } from "$utils";
export default {
  components: {
    AddIntegratedPerson,
  },
  props: {
    integratedGroupCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      viewerInstance: null,
      viewerPhotos: [],
      selectedPeople: [],
      tableData: [],
      // personType: [
      //   {
      //     id: 1,
      //     label: "保卫",
      //   },
      //   {
      //     id: 2,
      //     label: "员工",
      //   },
      // ],
      personType: [
      {
          label: "保卫",
          id: "1",
        },
        {
          label: "员工",
          id: "2",
        },
        {
          label: "库管",
          id: "3",
        },
        {
          label: "门卫",
          id: "4",
        },
      ],
      filterForm: {
        name: "",
        position: "",
        personOrAccountType: "",
      },
      page: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
    };
  },
  watch: {
    integratedGroupCode(newVal) {
      this.getTableData();
    },
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    accountTypeRender(value) {
      if (value == '1') {
        return '保卫'
      } else if (value == '2') {
        return '员工'
      } else if (value == '3') {
        return '库管'
      } else if (value == '4') {
        return '门卫'
      }
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    showViewer(src, e) {
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getTableData();
    },
    pageChange(pageNo) {
      this.page.currentPage = pageNo;
      this.getTableData();
    },
    handleSelectionChange(val) {
      if (!val || !val.length) {
        this.selectedPeople = [];
      } else {
        this.selectedPeople = val.map((item) => {
          return {
            personOrAccountCode: item.personOrAccountCode,
            integratedGroupCode: item.integratedGroupCode,
          };
        });
      }
    },
    getImgPath(item) {
      const path = item ? Bus.imgPath(item) : "";
      return path;
    },
    getSrcList(code, e) {
      if (!code) return;
      return [this.getImgPath(code)];
    },
    handleAdd() {
      this.$refs.modal.open({ integratedGroupCode: this.integratedGroupCode });
    },
    handleQuery() {
      this.getTableData();
    },
    handleReset() {
      this.filterForm = {
        name: "",
        personOrAccountType: "",
        position: "",
      };
      this.getTableData();
    },
    async getTableData() {
      const params = {
        integratedGroupCode: this.integratedGroupCode,
        name: this.filterForm.name,
        personOrAccountType: this.filterForm.personOrAccountType,
        position: this.filterForm.position,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      try {
        const {
          success,
          returnObj: { list, total },
        } = await this.$fetch(api.queryIntegratedGroupInfo, params);
        if (success) {
          this.tableData = list;
          this.page.total = total;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async delTableData() {
      if (!this.selectedPeople.length) {
        this.$message.warning("请选择数据");
        return;
      }
      try {
        const res = await this.$confirm(
          "您确定将人员从所属应急组移除吗?",
          "移除确认",
          {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        if (!res) return;
        const { success, msgConten } = await this.$fetch(
          api.deleteIntegratedGroupInfo,
          this.selectedPeople
        );
        if (success) {
          this.getTableData();
        } else {
          msgContent && this.$message.warning(msgConten);
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@src/common/assets/style/mixin";
.integrated-right {
  height: calc(100% - 146px);
  display: flex;
  flex-direction: column;
  position: relative;
  .integrated-table {
    flex: 1;
    height: 100%;

    // border: 1px solid red;
  }
  .operate-btns {
    /* padding-left: 20px; */
    height: 40px;
    line-height: 40px;
    // border-bottom: 1px solid #3e5574;
    margin: 0px 0 12px;
  }
  .filter-form {
    padding: 16px 12px 0;
    margin: 10px 0;
    @include set_theme_color(background-color, left-menu-bg-color);
  }
  .table-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    // background-color: #181f2e;
  }
  .footer {
    width: 100%;
    text-align: center;
  }
  .page-comp {
    margin: 10px 0;
  }
}
</style>
